<template>
  <b-card id="generalZoneInformation" class="p-sm-4 m-sm-4 my-4">
    <h5 v-if="circledNum" class="circled-number">{{ circledNum }}</h5>
    <h5 class="card-title pt-2">General Zone Information</h5>
    <b-row no-gutters>
      <b-col>
        <b-row>
          <b-col>
            <div class="pr-0 pr-md-2">
              <b-form-group>
                <cool-label>Placement Name (Internal Reference)</cool-label>
                <b-form-input
                  type="text"
                  required
                  v-model="zone.name"
                  placeholder="Enter placement name">
                </b-form-input>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Integration Method"
              description="Technical integration used">
              <b-form-select
                v-model="zone.integration"
                :options="integrationOptions"
                required>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4">
            <cool-label class="my-3">
              Position on Page
              <span v-b-popover.hover.click.right="'Select the option that most closely describes the location of the zone on your page.'"><span class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
            </cool-label>
            <b-form-group>
              <b-form-select
                v-model="zone.pos"
                :options="positionOnPageOptions" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="PMP Only"
              description="Restrict inventory to sale ONLY via private deal">
              <toggle-button
                v-model="zone.pmp_only"
                :sync="true"
                color="var(--primary)">
              </toggle-button>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Test Mode"
              description="Force test bids for placement">
              <toggle-button
                v-model="zone.force_bid"
                :sync="true"
                color="var(--primary)">
              </toggle-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6" class="mt-3 mt-md-0">
        <div class="pl-0 pl-md-2">
          <b-card bg-variant="lighter">
            <h5><span class="text-primary icon icon-Support"></span> Need help?</h5>
            <b-row>
              <b-col xl=6>
                <p>We would be more than happy to assist you in filling out this form.</p>
              </b-col>
              <b-col xl=6>
                <b-btn :to="{ name: 'Support' }" size="sm" variant="light">Contact Support</b-btn>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>


<style scoped>
  .card-button:hover {
    border-color: #DDD;
    transition: 0.1s;
  }

  .card-multi-select:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 5px;
    left: 5px;
    border: 2px solid #e3eaef;
    border-radius: 4px;
    height: 20px;
    width: 20px;
  }

  .card-multi-selected:after {
    font-family: icomoon;
    position: absolute;
    top: -9px;
    left: -2px;
    font-size: 2rem;
    content: "\e912";
    color: var(--primary);
  }
</style>

<script type="text/javascript">
    import {toggleInArray} from '@/components/utils.js'

    export default {
        props: {
            circledNum: {required: false, type: String},
            zone: {required: true, type: Object}
        },
        data() {
            return {
                positionOnPageOptions: [
                    { value: 'ATF', text: 'Above the fold' },
                    { value: 'BTF', text: 'Below the fold' },
                    { value: 'HEADER', text: 'Header' },
                    { value: 'FOOTER', text: 'Footer' },
                    { value: 'SIDEBAR', text: 'Sidebar' },
                    { value: 'FULLSCREEN', text: 'Fullscreen' },
                    { value: 'UNKNOWN', text: 'Unknown' }
                ],
                integrationOptions: [
                    { value: 'PREBIDJS', text: 'Prebid.JS' },
                    { value: 'PBIAB', text: 'SmartTag' },
                    { value: 'PREBIDSERVER', text: 'Prebid Server' },
                    { value: 'RTB', text: 'OpenRTB' },
                    { value: 'VAST', text: 'Vast Tag' },
                    { value: 'JSTAG', text: 'JS Tag' }
                ]
            }
        },
        methods: {
            toggleInArray
        }
    }

</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/GeneralZoneInformation.vue